import { Component, ElementRef, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { DialogRef } from '@ngneat/dialog';
import { isMobileView } from '@core/utils';
import { RoomType, SectionType } from '@core/enums';
import { RoomsComposition } from '@shared/compositions';
import { NumberInputDirective } from '@shared/directives';
import { ButtonComponent, DropdownComponent, IconComponent, ImageSelectorComponent } from '@shared/components/ui';
import { FormErrorComponent, TimePickerInputComponent } from '@shared/components';
import { TippyModule } from '@ngneat/helipopper';

@Component({
  selector: 'app-room-form',
  imports: [
    CommonModule,
    ButtonComponent,
    DropdownComponent,
    FormErrorComponent,
    FormsModule,
    IconComponent,
    ImageSelectorComponent,
    NgSelectModule,
    ReactiveFormsModule,
    TimePickerInputComponent,
    TranslateModule,
    NumberInputDirective,
    TippyModule,
  ],
  templateUrl: './room-form.component.html',
  styleUrls: ['./room-form.component.scss'],
})
export class RoomFormComponent extends RoomsComposition implements OnInit {
  protected readonly isMobileView = isMobileView();
  protected readonly RoomType = RoomType;
  protected readonly SectionType = SectionType;
  private readonly _elRef = inject(ElementRef);

  constructor() {
    super();
    if (!isMobileView()) {
      this._dialogRef = inject(DialogRef);
    }
  }

  get isUpdateMode(): boolean {
    return !!(this.currentRoom && this.currentRoom.id && this.currentRoom.imageUrl);
  }

  get roomId(): number {
    return this.currentRoom?.id || null;
  }

  ngOnInit() {
    this._InitDataForForm();
    if (this._dialogRef && this._dialogRef.data && this._dialogRef.data.room) {
      this.currentRoom = this._dialogRef.data.room;
    } else if (this._bottomSheet && this._bottomSheet.currentSheetData) {
      this.currentRoom = this._bottomSheet.currentSheetData.room;
    }

    if (this.currentRoom && this.currentRoom.id) {
      this._patchFormValues(this.currentRoom);
    }
  }

  close() {
    if (this._dialogRef) {
      this._dialogRef.close();
    } else {
      this._bottomSheet.closeAll();
    }
  }

  save(btnRef?: ButtonComponent) {
    if (this.form.invalid) {
      this.markAllInvalidControlsAndScrollToFirst(this.form, this._elRef);
      return;
    }
    this._createRoom(this.form.value, btnRef);
  }
}
